// import dependencies
import api from '../../marketing/api';
import { each, selectAll } from '../../shared/utils/dom';

const mounted = function () {
  api.get('/status', {}, false)
    .then(response => {
      if (!(response && typeof (response.data) === 'object' && response.data.loggedIn)) {
        location.reload();
      }
    })
    .catch(() => {
      location.reload();
    });
};

// Authenticated user apps
const buttons = selectAll('[data-vue-app="authenticated-user"]');
if (buttons && buttons.length) {
  // initialize the apps
  each(buttons, (el) => {
    new Vue({ // eslint-disable-line no-new
      el,
      mounted,
    });
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/authenticated-user.js